import { connect } from 'react-redux';

import MeetingView from './MeetingView';

import {
  mapStateToProps,
  mapDispatchToProps,
} from './props';

export default connect(mapStateToProps, mapDispatchToProps)(MeetingView);
